<template>
  <div class="row">
    <div class="col-12 d-flex align-items-center">
      <h2>{{ $t('payment_provider_accounts.payment_provider_account', 2).capitalize() }}</h2>
      <router-link class="btn btn-primary btn-sm ms-3" :to="{name: ROUTES.PAYMENT_PROVIDER_ACCOUNTS.CREATE}">
        <i class="fas fa-file-circle-plus"/> {{ $t('payment_provider_accounts.create') }}
      </router-link>
    </div>

    <div class="col-12">
      <DataTable stripedRows :lazy="true"
                 :paginator="true"
                 :rows="paymentProviderAccountStore.serverOptions.rows"
                 :totalRecords="paymentProviderAccountStore.itemLength"
                 dataKey="id"
                 :value="paymentProviderAccountStore.payment_provider_accounts"
                 :loading="paymentProviderAccountStore.loading"
                 paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                 :rowsPerPageOptions="[10,20,50]"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                 @page="onPage($event)"
                 responsiveLayout="scroll">
        <TableColumn field="id" :header="$t('payment_provider_accounts.id')"/>
        <TableColumn field="organization_id" :header="$t('payment_provider_accounts.organization_id')"/>
        <TableColumn field="provider_key" :header="$t('payment_provider_accounts.provider_key')"/>
        <TableColumn field="name" :header="$t('payment_provider_accounts.name')"/>
        <TableColumn field="status" :header="$t('payment_provider_accounts.status')"/>
        <TableColumn field="default_currency" :header="$t('payment_provider_accounts.default_currency')"/>
        <TableColumn field="webhook_url" :header="$t('payment_provider_accounts.webhook_url')"/>
        <TableColumn field="updated_at" :header="$t('payment_provider_accounts.updated_at')">
          <template #body="{data}">
            {{ formatDate(data.updated_at, 'datetime') || '-' }}
          </template>
        </TableColumn>
        <TableColumn :header="$t('payment_provider_accounts.operations')">
          <template #body="{data}">
            <div class="operations-wrapper">
              <router-link class="operation-item"
                           :to="{name: ROUTES.PAYMENT_PROVIDER_ACCOUNTS.SHOW, params: {id: data.id}}"
                           :title="$t('payment_provider_accounts.show')">
                <i class="fas fa-eye"/>
              </router-link>
              <router-link class="operation-item"
                           :to="{name: ROUTES.PAYMENT_PROVIDER_ACCOUNTS.EDIT, params: {id: data.id}}"
                           :title="$t('payment_provider_accounts.edit')">
                <i class="fas fa-edit"/>
              </router-link>
            </div>
          </template>
        </TableColumn>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {usePaymentProviderAccountStore} from "@/stores/payment_provider_account";
import {ROUTES} from "@/scripts/constants";

export default {
  name: 'PaymentProviderAccountsIndex',
  setup() {
    return {
      paymentProviderAccountStore: usePaymentProviderAccountStore(),
    }
  },
  computed: {
    ROUTES() {
      return ROUTES
    }
  },
  created() {
    this.getPaymentProviderAccounts()
    this.setTitle(this.$t('payment_provider_accounts.payment_provider_account', 2).capitalize())
  },
  methods: {
    getPaymentProviderAccounts() {
      this.paymentProviderAccountStore.index()
    },
    onPage(event) {
      this.paymentProviderAccountStore.serverOptions = event
      this.getPaymentProviderAccounts()
    }
  }
}
</script>
